<!--  -->
<template>
  <div class="back">
    <section class="course-details-section">
      <div class="container">
        <div class="single-course-area">
          <div class="sc-thumb">
            <!-- <vue-baberrage
                    :isShow= "barrageIsShow"
                    :barrageList = "barrageList"
                    :loop = "barrageLoop"
                    :style="`height: ${videoHigh};z-index: 80`"
                    @dbclick="chgPlaystatus"
                    >
                  </vue-baberrage> -->
            <div class="nolive" v-if="!isLiving"></div>
            <!-- <div v-if="!isLiving" style="background-color: #fff;">课程讲师暂未开播，去逛逛在线课程吧！</div> -->

            <!-- <video-play v-else-if="flvInfo" :flvInfo="flvInfo"></video-play> -->
            <!-- <LivePlayer v-else-if="flvInfo" :videoUrl="flvInfo.url" fluent autoplay live stretch></LivePlayer> -->
            <!-- <div id="jh_live" style="width:100%; height:auto;" ref="VideoPlay"></div> -->
          </div>
          <!-- <div class="chartbox">
            <div class="info-course">
              <div class="livechat">
                <span>在线交流</span>
                <span class="livenum">{{ linvClient ? linvClient.active : 0 }}</span>
              </div>
              <div class="chat-content" id="chatRecord" style="overflow: auto;" updated>
               
                <div v-for="(itemc, indexc) in recordContent" :key="indexc">
                  
                  <div class="word" v-if="!itemc.mineMsg">
                    <img :src="itemc.headUrl">
                    <div class="info">
                      <p class="time">{{ itemc.nickName }} {{ itemc.timestamp }}</p>
                      <div class="info-content">{{ itemc.contactText }}</div>
                    </div>
                  </div>
                 
                  <div class="word-my" v-else>
                    <div class="info">
                      <p class="time">{{ itemc.nickName }} {{ itemc.timestamp }}</p>
                      <div class="info-content">{{ itemc.contactText }}</div>
                    </div>
                    <img :src="itemc.headUrl">
                  </div>
                </div>
              </div>
            </div>
            <el-input placeholder="请输入聊天内容" v-model="msg">
              <el-button slot="append" @click="addToList()">发送</el-button>
            </el-input>
          </div> -->
        </div>
      </div>
      <div class="container">
        <div class="livetop">
          <a class="topclick" :class="istopclick && 'istopclick'" @click="topClick">{{ topclick }}</a>
          <div class="livesum">{{ livesum }}</div>
          <div class="livetrack">
            <span>分享</span>
            <a class="weixin" href="javascript:;"></a>
            <a class="qq" href="javascript:;"></a>
          </div>
        </div>
      </div>
       <div class="container">
           <div class="course-top">
            <div class="title">
              <h4>{{ liveInfo.title }}</h4>
              <span>{{ linvClient.active ? linvClient.active : 0 }}人在线</span>
            </div>
              <div class="titleinfo">test辅导时间焚枯食淡回风口凤凰首府肯定是开发贷款v出发</div>
              <div class="course-meta">
                <div class="author">
                  <img src="/static/img/a1.png" alt="">
                  <a>{{ liveInfo.teacher }}</a>
                  <span>大学教授</span>
                </div>
                <div class="categories">
                    <span>所属科目:</span>
                    <a >{{liveInfo.type}}</a>
                </div>
                <div class="ratings">
                  <span>直播时间：</span>
                  <a>{{ dateFormat(new Date(liveInfo.time), "yyyy-MM-dd hh:mm") }}</a>
                </div>
              </div>
              <!-- <div class="course-price" style="text-align:center">
                      <span>在线人数</span>
                      {{ linvClient ? linvClient.active : 0 }}                
                    </div> -->
            </div>
        </div>
    </section>
    <div class="container">
          <div class="row">
            <div class="aboutlive">相关课程</div>
          </div>
          <div class="row course-item-wrap">
            <div v-for="(live, index) in lives" :key="index">
              <div class="post-item-1" :class="(index + 1) % 3 === 0 && 'post-item-clear'"
                @click="$router.push(`/mylive/${live._id}`)">
                <div class="img">
                  <img :src="`${global.remoteIp}/uploads/${live.picsrc}`" width="344" height="262" alt="">
                </div>
                <div class="b-post-details">
                  <h3><a>{{ live.title }}</a></h3>
                  <div class="bp-meta">
                    <a class="a-color">{{ dateFormat(new Date(live.time), "yyyy-MM-dd hh:mm") }}</a>
                    <a class="a-color a-changebac">{{ live.teacher }}</a>
                  </div>
                  <a class="read-more">{{ live.state == '1' ? '正在直播' : '暂未开播' }}<i v-if="live.state == '1'"
                      class="arrow_right"></i></a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="pagination-wrap">
              <el-pagination background :page-size="3" :hide-on-single-page="intTotal <= 3" layout="prev, pager, next"
                @current-change="toPage" @prev-click="toPage" @next-click="toPage" :total="intTotal">
              </el-pagination>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
// import LivePlayer from '@liveqing/liveplayer'
//import VideoPlay from "../components/PublicComs/VideoPlay.vue";
// import { MESSAGE_TYPE } from 'vue-baberrage'
export default {
  data() {
    return {
      lives: [],
      intCurrent: 1,
      intTotal: 20,
      global,
      liveInfo: {},
      flvInfo: null,
      isLiving: true,
      recordContent: [],
      linvClient: {},
      msg: '',
      barrageIsShow: true,
      currentId: 0,
      barrageLoop: false,
      barrageList: [],
      videoHigh: 100,
      player: {},
      timer: {},
      topclick: 0,
      livesum: 120,
      istopclick: false,
    };
  },
  props: {
    plates: Array,
  },
  components: {},

  computed: {},
  updated() {
    // 聊天定位到底部
    let ele = document.getElementById('chatRecord');
    ele.scrollTop = ele.scrollHeight;
  },

  mounted() {
    this.$axios.get(`/api/livings?page=1&limit=3`).then((res) => {
      if (res.data) {
        this.intTotal = res.data.total;
        this.lives = res.data.data;
      }
    });
    let liveId = this.$route.params.id;
    // let liveId = "61ac6fc73ffc156948d5aa6b";
    this.$axios.get(`/api/livings/${liveId}`).then((res) => {
      if (res.data) {
        this.liveInfo = res.data.data;
        if (!this.liveInfo.addtime) {
          let addtime = this.liveInfo.createdAt;
          let date = new Date(addtime);
          this.liveInfo.addtime = `${date.getFullYear()}-${(
            "00" +
            (date.getMonth() + 1)
          ).slice(-2)}-${("00" + date.getDate()).slice(-2)} ${(
            "00" + date.getHours()
          ).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${(
            "00" + date.getSeconds()
          ).slice(-2)}`;
        }
        if (this.liveInfo.state !== 1) {
          this.isLiving = false;
          return;
        }
        this.flvInfo = {
          id: this.liveInfo._id,
          url: this.global.liveIp + liveId + ".flv",
        };
        this.playVideo(this.global.liveIp + liveId);//".m3u8"
        this.$nextTick(function () {
          this.videoHigh = (this.$refs.VideoPlay.clientHeight - 20) / 1.5 + "px";
        })
      }
    });
    this.joinLiveRoom(liveId);
    this.$axios.get("/users/" + liveId).then((res) => {
      if (res && res.data) {
        this.linvClient.active = res.data.data;
        this.$forceUpdate();
      }
    })
    this.timer = setInterval(() => {
      this.$axios.get("/users/" + liveId).then((res) => {
        if (res && res.data) {
          this.linvClient.active = res.data.data;
          this.$forceUpdate();
        }
      })
    }, 1000 * 60);
    this.$socketBarrage.on("chatLiveRoom", (res) => {
      console.log(res)
      this.barrageList.push({
        id: ++this.currentId,
        avatar: "/static/images/avatar.png",
        msg: res.msg,
        time: 5,
        type: MESSAGE_TYPE.NORMAL,
      });
      this.recordContent.push({
        mineMsg: res.user == this.$store.getters.user.name,
        nickName: res.user,
        timestamp: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
        headUrl: "/static/images/avatar.png",
        contactText: res.msg
      })
      this.$nextTick(() => {
        // this.$refs.barrageList.scrollTop = this.$refs.barrageList.clientHeight;
      });
    });
    window.addEventListener("keydown", this.keyDown);
    window.addEventListener('beforeunload', () => {
      console.log("come here")
      this.leaveLiveRoom(this.liveInfo._id)
    });
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.keyDown, false);
    clearInterval(this.timer);
  },

  methods: {
    toPage(intcount) {
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      this.$axios
        .get(
          `/api/livings?page=${this.intCurrent
          }&limit=3${searchConditions}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.lives = res.data.data;
          }
        });
    },
    topClick() {
      this.istopclick = !this.istopclick;
      if (this.istopclick) {
        this.topclick++;
      } else {
        this.topclick--;
      }
    },
    chgPlaystatus() {
      this.player.togglePlay();
    },
    addToList() {
      //发送弹幕
      if (!this.msg) return;
      let data = {
        room: this.liveInfo._id,
        func: "chatLiveRoom",
        data: {
          id: this.global.getCode(8),
          user: this.$store.getters.user.name,
          msg: this.msg,
        },
      };
      this.msg = "";
      this.$sockBarrage.roomChat(data);
      // this.barrageList.push({
      //   id: ++this.currentId,
      //   avatar: "/static/images/avatar.png",
      //   msg: this.msg,
      //   time: 5,
      //   type: MESSAGE_TYPE.NORMAL,
      // });
      // this.recordContent.push({
      //   mineMsg:true,
      //   nickName:this.$store.getters.user.name,
      //   timestamp:this.dateFormat(new Date(),"yyyy-MM-dd hh:mm:ss"),
      //   headUrl:"/static/images/avatar.png",
      //   contactText:this.msg
      // })
    },
    dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
    //加入直播间
    joinLiveRoom(name) {
      this.$sockBarrage.joinRoom(name);
    },

    //离开直播间
    leaveLiveRoom(name) {
      this.$sockBarrage.leaveRoom(name);
    },
    keyDown(e) {
      //如果是按回车则执行登录方法
      if (e.keyCode == 13) {
        this.addToList();
      }
    },
    playVideo(url) {
      document.getElementById('jh_live').innerHTML = ""
      this.player = new this.TcPlayer('jh_live', {
        "m3u8": url, //请替换成实际可用的播放地址
        "autoplay": true, //iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
        // "poster": img,
        "width": '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
        "height": '100%', //视频的显示高度，请尽量使用视频分辨率高度
        "remember": 1
      });
    },
  },
};
</script>
<style scoped>
::v-deep .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 0px;
}

::v-deep .el-dialog__body {
  padding: 5px 20px 30px 20px;
}

::v-deep .el-dialog__title {
  color: #233d63;
  font-size: 29px;
  line-height: 33px;
  font-weight: 500;
}

::v-deep .el-empty__description p {
  color: #ff0000;
  font-size: 20px;
  margin: 0;
  font-weight: 600;
}

.chat-content {
  width: 100%;
  padding: 20px;
  height: 460px;
  box-shadow: 0 2px 2px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);
}

.chat-content .word {
  display: flex;
  margin-bottom: 20px;
}

.chat-content .word img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.chat-content .word .info {
  margin-left: 10px;
}

.chat-content .word .info .time {
  font-size: 12px;
  color: rgba(51, 51, 51, 0.8);
  margin: 0;
  height: 20px;
  line-height: 20px;
  margin-top: -5px;
}

.chat-content .word .info .info-content {
  padding: 10px;
  font-size: 14px;
  background: #fff;
  position: relative;
  margin-top: 8px;
}

.chat-content .word .info .info-content::before {
  position: absolute;
  left: -8px;
  top: 8px;
  content: "";
  border-right: 10px solid #fff;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
}

.word-my {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.word-my img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.word-my .info {
  width: 90%;
  margin-left: 10px;
  text-align: right;
}

.word-my .info .time {
  font-size: 12px;
  color: rgba(51, 51, 51, 0.8);
  margin: 0;
  height: 20px;
  line-height: 20px;
  margin-top: -5px;
  margin-right: 10px;
}

.word-my .info .info-content {
  max-width: 70%;
  padding: 10px;
  font-size: 14px;
  float: right;
  margin-right: 10px;
  position: relative;
  margin-top: 8px;
  background: #a3c3f6;
  text-align: left;
}

.word-my .info .info-content::after {
  position: absolute;
  right: -8px;
  top: 8px;
  content: "";
  border-left: 10px solid #a3c3f6;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
}

::-webkit-scrollbar {
  width: 14px;
  height: 14px;
}

::-webkit-scrollbar-track,
::-webkit-scrollbar-thumb {
  border-radius: 999px;
  border: 5px solid transparent;
}

::-webkit-scrollbar-track {
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2) inset;
}

::-webkit-scrollbar-thumb {
  min-height: 20px;
  background-clip: content-box;
  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2) inset;
}

::-webkit-scrollbar-corner {
  background: transparent;
}

.single-p-banner .bp-meta {
  height: 20px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 20px;
}

.single-p-banner .bp-meta a i,
.single-p-banner .bp-meta a {
  color: #000000;
}

.box {
  padding-left: 29px;
  padding-top: 62px;
}

.bp-meta {
  padding-left: 4px;
}

.course-details-section {
  position: relative;
  padding-top: 67px;
  height: 891px;
  background: linear-gradient(to bottom,#EFF3FF 1%, #FFFFFF 90%);
}

.course-top .title {
  width: 1200px;
  height: 32px;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 32px;
  padding-bottom: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.course-top .title h4{
  height: 32px;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 32px;
}
.course-top .title span{
  padding: 0 19px;
height: 38px;
background: #DBE2FF;
border-radius: 5px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #4462CF;
line-height: 38px;
}
.titleinfo{
  margin: 10px 0;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #4A576A;
line-height: 18px;
overflow: hidden;
}
.author img {
  width: 40px;
  height: 40px;
}

.author a {
  padding: 0 14px;
  height: 40px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #4A576A;
  line-height: 40px;
  display: inline-block;
}

.author span {
  display: inline-block;
  width: 69px;
  height: 21px;
  background: #00D57A;
  border-radius: 3px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 21px;
  color: #FFFFFF;
  text-align: center;
}

.ratings {
  height: 40px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #4A576A;
  line-height: 40px;
  padding-left: 50px;
  background-image: url('/static/img/zhiboshijain.png');
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: 29px center;
}
.course-meta{
  display: flex;
  justify-content: start;
  align-items: center;
}
.course-meta .author {
  width: 202px;
  display: flex;
  justify-content: start;
  align-items: center;
}

.chartbox {
  width: 345px;
  height: 475px;
  background: #E9EBF5;
  box-shadow: 0px 2px 14px 0px rgba(120, 120, 120, 0.24);
}

.sc-thumb {
  position: relative;
  width: 1200px;
  height: 551px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.single-course-area {
  width: 1200px;
  height: 551px;
  background-image: url('/static/img/zhibozhongxi.png');
  display: flex;
  justify-content: space-between;
}

.nolive {
  width: 60px;
  height: 60px;
  background-image: url('/static/img/bofangheise.png');
  background-size: 60px 60px;
}

.livechat {
  width: 345px;
  height: 35px;
  background: #F8F8F8;
  font-size: 16px;
  font-family: FZHei-B01S;
  font-weight: 400;
  color: #606060;
  line-height: 35px;
  padding-left: 11px;
  padding-right: 18px;
  display: flex;
  justify-content: space-between;
}

.livenum {
  padding-left: 22px;
  background-image: url('/static/img/renshu.png');
  background-repeat: no-repeat;
  background-size: 14px 12px;
  background-position: 0 center;
  font-size: 16px;
  font-family: FZHei-B01S;
  font-weight: 400;
  color: #606060;
}

#chatRecord {
  width: 345px;
  height: 394px;
}

.chartbox>>>.el-input {
  width: 345px;
  height: 46px;
  background: #F8F8F8;
  border-radius: 3px;
  overflow: hidden;
}

.chartbox>>>.el-input .el-input__inner {
  width: 270px;
  padding-left: 17px;
  padding-right: 9px;
  height: 46px;
  line-height: 46px;
  border: none;

  background: #F8F8F8;

}

.chartbox>>>.el-input .el-input-group__append {
  width: 74px;
  height: 46px;
  background: #F55C57;
  color: #FFFFFF;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 46px;
}

.course-top {
  margin: 0 0 18px 0;
  padding-right: 0;
}

.livetop {
  position: relative;
  margin-top: 19px;
  margin-bottom: 56px;
  width: 1200px;
  height: 25px;
  display: flex;
  justify-content: start;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
  line-height: 25px;
}

.topclick {
  color: #999999;
  line-height: 25px;
  padding-left: 40px;
  background-image: url('/static/img/zan1.png');
  background-repeat: no-repeat;
  background-size: 25px 25px;
  background-position: 0 center;
}

.istopclick {
  background-image: url('/static/img/zan2.png');
}

.livesum {
  margin-left: 81px;
  flex: 1;
  line-height: 25px;
  padding-left: 33px;
  background-image: url('/static/img/yanji.png');
  background-repeat: no-repeat;
  background-size: 24px 18px;
  background-position: 0 center;
}

.livetrack {
  width: 100px;
  height: 25px;
  display: flex;
  justify-content: start;
  align-items: center;
}

.livetrack span {
  display: inline-block;
  width: 37px;
  height: 25px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 25px;
}

.livetrack a {
  display: inline-block;
  width: 25px;
  height: 25px;
}

.livetrack a.weixin {
  background-image: url('/static/img/weixin.png');
  background-repeat: no-repeat;
  background-size: 25px 25px;
  background-position: 0 center;
  margin-right: 11px;
}

.livetrack a.qq {
  background-image: url('/static/img/qq.png');
  background-repeat: no-repeat;
  background-size: 25px 25px;
  background-position: 0 center;
}

.a-color {
  padding-left: 25px;
  position: relative;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #959595 !important;
  line-height: 16px;
  background-image: url(/static/img/time-line.png);
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: left center;
}

.a-changebac {
  margin-left: 65px;
  background-image: url('/static/img/user-6-line (1)hong.png');
}

/* fenyeqi s */
.pagination-wrap>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
  width: 25px;
  min-width: 25px;
  height: 25px;
  background: #4462CF;
  border-radius: 50%;
  line-height: 25px;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li:not(.active):hover {
  color: #4462CF;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li {
  width: 25px;
  min-width: 25px;
  height: 25px;
  background: #EEEEEF;
  border-radius: 50%;
  line-height: 25px;
}

.pagination-wrap>>>.el-pagination.is-background .btn-prev {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 1px solid #4462CF;
  border-radius: 50%;
  background: #fff;
  color: #4462CF;
}

.pagination-wrap>>>.el-pagination.is-background .btn-next {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 1px solid #4462CF;
  border-radius: 50%;
  background: #fff;
  color: #4462CF;

}

.pagination-wrap>>>.el-pagination .btn-prev .el-icon {
  font-size: 16px;
}

.pagination-wrap>>>.el-pagination .btn-next .el-icon {
  font-size: 16px;
}

.pagination-wrap>>>.el-pagination {
  width: 1200px;
  text-align: right;
  height: 35px;
  padding-top: 4px;
  padding-bottom: 40px;
}

.pagination-wrap>>>.el-pager {
  height: 35px;
}

.pagination-wrap>>>.el-pager li {
  padding: 0;
  font-size: 14px;
  color: #666666;
}
.course-details-section {
  padding-bottom: 0;
}

.aboutlive {
  padding-left: 1px;
  margin-bottom: 33px;
  height: 30px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 30px;
}
.post-item-1 {
  position: relative;
  margin-right: 30px;
  margin-bottom: 42px;
  width: 380px;
  height: 437px;
  background: #FFFFFF;
  box-shadow: 0px 0px 24px 0px rgba(225, 211, 211, 0.35);
  border-radius: 20px;
  padding: 15px 18px;
}

.post-item-clear {
  margin-right: 0px;
}

.post-item-1 div.img {
  width: 344px;
  height: 262px;
  background: #FFF1F1;
  border-radius: 20px;
  overflow: hidden;
}

.b-post-details {
  position: relative;
  padding-top: 23px;
}

.bp-meta {
  position: relative;
  display: flex;
  justify-content: flex-start;
  margin: 0 0 40px;
}

.bp-meta a {
  display: inline-block;
  font-size: 16px;
  line-height: 16px;
  font-family: PingFang SC;
  color: #000000;
  font-weight: 500;
  margin-right: 30px;
}

.bp-meta a i {
  color: #F55C57;
  margin-right: 9px;
  position: relative;
  top: 1px;
}

.bp-meta a:last-child {
  margin-right: 0;
}

.bp-meta a:hover {
  color: #F55C57;
}

.b-post-details h3 {
  height: 19px;
  font-size: 19px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 19px;
  margin-bottom: 22px;
}


.b-post-details h3 a:hover {
  color: #F55C57;
}

.post-item-1:hover {
  -webkit-box-shadow: 0px 30px 50px 0px rgba(11, 02, 55, 0.10);
  -moz-box-shadow: 0px 30px 50px 0px rgba(11, 02, 55, 0.10);
  box-shadow: 0px 30px 50px 0px rgba(11, 02, 55, 0.10);
}
.a-color{
  padding-left:25px ;
  position: relative;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #959595 !important;
line-height: 16px ;
background-image: url(/static/img/icon_shijainhasohi.png);
background-repeat: no-repeat;
background-size: 16px 16px;
background-position: left center;
}
.a-changebac{
  margin-left: 65px;
  background-image: url('/static/img/user-6-line (1)hong.png');
}
/* fenyeqi s */
</style>
